import React from 'react';
import clsx from 'clsx';
import { getArchiveIcon } from '@isyc-react/archives/view/tools';
import { RippleButton } from '@isyc-react/form/modules/base';
import { useTrail, a } from '@isyc-react/animation/lib';
import { useTranslation } from 'react-i18next';
import '@isyc-react/design/main';
import { nsformfile } from '@isyc-react/form-file/i18n/namespaces';
import { DropPreview } from '@isyc-react/form-file/modules/drop-file/drop-preview';
import { OverlayTrigger, Tooltip } from '@isyc-react/design/bootstrap';
export const DropSingleAcceptedView = props => {
    const { accepted, open, remove, disabled } = props;
    const { t } = useTranslation(nsformfile.common);
    const [preview, setPreview] = React.useState(false);
    const name = React.useMemo(() => { var _a; return (accepted.file ? accepted.file.name : (_a = accepted.api) === null || _a === void 0 ? void 0 : _a.name); }, [accepted]);
    const classes = getArchiveIcon(name);
    const trail = useTrail(2, {
        config: { mass: 1, tension: 100, friction: 10 },
        from: { opacity: 0, transform: 'translate3d(0px,50px,0)' },
        to: { opacity: 1, transform: 'translate3d(0,0,0)' },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'row' },
            React.createElement(a.div, { className: 'col d-flex align-items-center justify-content-center', style: trail[0] },
                React.createElement("div", { className: 'text-start' },
                    React.createElement("div", { className: 'd-flex align-items-center' },
                        React.createElement("i", { className: clsx(classes.icon, 'font-size-22 me-2') }),
                        React.createElement("span", { className: 'text-nowrap' }, name)))),
            React.createElement(a.div, { className: 'd-flex my-2 justify-content-center', style: trail[1] },
                React.createElement(OverlayTrigger, { overlay: React.createElement(Tooltip, null, "Visualiser") },
                    React.createElement(RippleButton, { onClick: () => {
                            setPreview(true);
                        }, type: 'button', className: 'btn btn-lg btn-pill btn-outline-primary only-icon me-2' },
                        React.createElement("i", { className: 'mdi mdi-eye text-black font-size-17 fw-bold' }))),
                !disabled && (React.createElement(OverlayTrigger, { overlay: React.createElement(Tooltip, null, "Modifier") },
                    React.createElement(RippleButton, { onClick: open, type: 'button', className: 'btn btn-lg btn-pill btn-outline-primary only-icon me-2' },
                        React.createElement("i", { className: 'mdi mdi-pen text-black font-size-17 fw-bold' })))
                // <RippleButton className='btn btn-outline-primary me-2' >
                //   {t('drop.zone.accepted.change')}
                // </RippleButton>
                ),
                !disabled && !accepted.api && (React.createElement(OverlayTrigger, { overlay: React.createElement(Tooltip, null, "Supprimer") },
                    React.createElement(RippleButton, { onClick: remove, type: 'button', className: 'btn btn-lg btn-pill btn-outline-danger only-icon me-2' },
                        React.createElement("i", { className: 'mdi mdi-close text-danger font-size-17 fw-bold' })))
                // <RippleButton type='button' className='btn btn-outline-primary' onClick={remove}>
                //   {t('drop.zone.accepted.remove')}
                // </RippleButton>
                )),
            React.createElement(DropPreview, { value: accepted, show: preview, onChange: setPreview }))));
};
